import { BaseQuery, MarketingInputUpdate } from 'generated/graphql';
import { mapBaseQueryFields } from './BaseQueryInputUpdateMapper';

export const mapToMarketingInputUpdate = (
  q: BaseQuery,
  assignee?: string
): MarketingInputUpdate => {
  return {
    ...mapBaseQueryFields(q, assignee),
    fileName: q.queryDetails?.__typename === 'MarketingQuery' ? q.queryDetails?.fileName : ''
  };
};
